import { Helmet } from "react-helmet-async";
import { SEO_CONFIG } from "../../seo/seoConfig";

export function PrivacyPolicy() {
  const seo = SEO_CONFIG.privacy;
  const siteName = "אתר עו״ד ארז עזרא";
  const ownerName = "עו״ד ארז עזרא";
  const email = "zlaw.adv@gmail.com";
  const phone = "03-5563036";
  const lastUpdated = "11/03/2026";

  return (
    <>
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        {seo.robots && <meta name="robots" content={seo.robots} />}
        <link rel="canonical" href={seo.canonical} />

        {/* hreflang (אם יש לך גלובלי תוכל גם להסיר פה בעתיד) */}
        <link rel="alternate" hrefLang="he" href={seo.canonical} />
        <link rel="alternate" hrefLang="x-default" href={seo.canonical} />

        {/* OG */}
        <meta property="og:title" content={seo.og.title} />
        <meta property="og:description" content={seo.og.description} />
        <meta property="og:url" content={seo.og.url} />
        <meta property="og:type" content={seo.og.type} />
        <meta property="og:site_name" content={seo.og.siteName} />
        <meta property="og:locale" content={seo.og.locale} />
        <meta property="og:image" content={seo.og.image} />

        {/* Twitter */}
        <meta name="twitter:card" content={seo.twitter.card} />
        <meta name="twitter:title" content={seo.twitter.title} />
        <meta name="twitter:description" content={seo.twitter.description} />
        <meta name="twitter:image" content={seo.twitter.image} />
      </Helmet>
      <main
        id="main"
        aria-labelledby="privacy-title"
        className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-black text-slate-100 pt-28 pb-24"
      >
        <a
          href="/"
          aria-label="חזרה לדף הבית"
          className="fixed top-6 right-6 z-[9999] inline-flex items-center gap-2
                   px-5 py-2.5 rounded-full
                   bg-slate-900/80 backdrop-blur-md
                   border border-white/10
                   text-slate-200
                   shadow-lg
                   hover:bg-slate-800 transition-all
                   focus-visible:ring-2 focus-visible:ring-blue-600"
        >
          ← חזרה לאתר
        </a>

        <div className="container mx-auto px-6 max-w-3xl">
          <header className="mb-12 text-center md:text-right">
            <h1
              id="privacy-title"
              className="text-4xl md:text-5xl font-bold mb-4 tracking-tight"
            >
              מדיניות פרטיות
            </h1>
            <p className="text-slate-400">עודכן לאחרונה: {lastUpdated}</p>
          </header>

          <div className="space-y-10 text-lg leading-relaxed max-w-2xl mx-auto md:mr-0">
            <p className="text-slate-300">
              {siteName} מכבד את פרטיות המשתמשים ופועל לשמירה על המידע האישי
              הנמסר במסגרת השימוש באתר ובהתאם להוראות הדין בישראל.
            </p>

            {/* איסוף מידע */}
            <section aria-labelledby="privacy-collection">
              <h2
                id="privacy-collection"
                className="text-2xl font-semibold text-white mt-10"
              >
                איסוף מידע
              </h2>
              <ul className="list-disc pr-6 space-y-2 text-slate-300">
                <li>שם מלא</li>
                <li>טלפון</li>
                <li>כתובת אימייל</li>
                <li>תוכן הפנייה בטופס</li>
              </ul>
            </section>

            {/* שימוש במידע */}
            <section aria-labelledby="privacy-usage">
              <h2
                id="privacy-usage"
                className="text-2xl font-semibold text-white mt-10"
              >
                שימוש במידע
              </h2>
              <p className="text-slate-300">
                המידע ישמש לצורך יצירת קשר, מתן מענה לפניות, תיאום פגישות, שיפור
                השירות וחוויית המשתמש באתר.
              </p>
            </section>

            {/* שמירת מידע */}
            <section aria-labelledby="privacy-retention">
              <h2
                id="privacy-retention"
                className="text-2xl font-semibold text-white mt-10"
              >
                שמירת מידע
              </h2>

              <p className="text-slate-300">
                המידע הנמסר באמצעות טופס יצירת הקשר באתר משמש לצורך מתן מענה
                לפנייה בלבד. המידע מועבר לבעל האתר באמצעות דואר אלקטרוני ואינו
                נשמר כמאגר מידע באתר עצמו.
              </p>

              <p className="text-slate-300">
                המידע יישמר רק ככל הנדרש לצורך טיפול בפנייה או בהתאם להוראות
                הדין.
              </p>
            </section>

            {/* אבטחת מידע */}
            <section aria-labelledby="privacy-security">
              <h2
                id="privacy-security"
                className="text-2xl font-semibold text-white mt-10"
              >
                אבטחת מידע
              </h2>
              <p className="text-slate-300">
                האתר עושה מאמצים סבירים לאבטחת המידע באמצעים טכנולוגיים
                וארגוניים מקובלים. יחד עם זאת, אין באפשרותנו להבטיח חסינות
                מוחלטת מפני חדירה בלתי מורשית.
              </p>
            </section>

            {/* מניעת ספאם */}
            <section aria-labelledby="privacy-spam">
              <h2
                id="privacy-spam"
                className="text-2xl font-semibold text-white mt-10"
              >
                מניעת ספאם ואבטחת טפסים
              </h2>
              <p className="text-slate-300">
                לצורך הגנה על האתר ומניעת שליחת הודעות ספאם או שימוש אוטומטי
                בטפסים, האתר עושה שימוש בשירות אבטחה בשם Cloudflare Turnstile.
              </p>

              <p className="text-slate-300">
                שירות זה עשוי לעבד מידע טכני כגון כתובת IP, נתוני דפדפן ודפוסי
                שימוש באתר לצורך אימות כי המשתמש הוא אדם ולא מערכת אוטומטית.
              </p>

              <p className="text-slate-300">
                מידע זה משמש אך ורק לצרכי אבטחה ומניעת שימוש לרעה בטפסים באתר.
              </p>
            </section>

            {/* מסירת מידע */}
            <section aria-labelledby="privacy-sharing">
              <h2
                id="privacy-sharing"
                className="text-2xl font-semibold text-white mt-10"
              >
                מסירת מידע לצד שלישי
              </h2>
              <p className="text-slate-300">
                המידע לא יועבר לצד שלישי, למעט במקרים בהם הדבר נדרש על פי דין,
                צו שיפוטי או רגולטורי, או לצורך מתן השירות המבוקש על ידי המשתמש.
              </p>
            </section>

            {/* Cookies */}
            <section aria-labelledby="privacy-cookies">
              <h2
                id="privacy-cookies"
                className="text-2xl font-semibold text-white mt-10"
              >
                שימוש בעוגיות (Cookies)
              </h2>
              <p className="text-slate-300">
                האתר עושה שימוש בעוגיות (Cookies) ובאחסון מקומי (Local Storage)
                לצרכים טכניים בלבד, כגון:
              </p>
              <ul className="list-disc pr-6 space-y-2 text-slate-300">
                <li>שמירת העדפות נגישות</li>
                <li>הגדרות תצוגה</li>
                <li>העדפות משתמש</li>
              </ul>
              <p className="text-slate-300">
                לא נעשה שימוש בעוגיות לצרכי פרסום, מעקב או יצירת פרופיל משתמשים.
              </p>
            </section>

            {/* זכויות משתמש */}
            <section aria-labelledby="privacy-rights">
              <h2
                id="privacy-rights"
                className="text-2xl font-semibold text-white mt-10"
              >
                זכויות המשתמש
              </h2>
              <p className="text-slate-300">
                כל משתמש רשאי לפנות אלינו בבקשה לעיון, תיקון או מחיקת מידע אישי
                שנמסר על ידו, בהתאם להוראות הדין.
              </p>
            </section>

            {/* יצירת קשר */}
            <section aria-labelledby="privacy-contact">
              <h2
                id="privacy-contact"
                className="text-2xl font-semibold text-white mt-10"
              >
                יצירת קשר בנושא פרטיות
              </h2>

              <p className="text-slate-300 leading-relaxed">
                בכל שאלה, בקשה או פנייה בנושא מדיניות הפרטיות, השימוש במידע אישי
                או זכויות המשתמש לפי הדין, ניתן לפנות אלינו באמצעות פרטי הקשר
                הבאים:
                <br />
                {ownerName}
                <br />
                טלפון:{" "}
                <a
                  href={`tel:${phone.replace(/-/g, "")}`}
                  className="text-blue-400 hover:text-blue-300 underline underline-offset-4"
                >
                  {phone}
                </a>
                <br />
                אימייל:{" "}
                <a
                  href={`mailto:${email}`}
                  className="text-blue-400 hover:text-blue-300 underline underline-offset-4"
                >
                  {email}
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>
    </>
  );
}
